import { $createParagraphNode, $getRoot, LexicalEditor, ParagraphNode } from "lexical";


const editorInitialJSON = JSON.stringify({
    root: {
      children: [
        {
          children: [],
          direction: null,
          format: '',
          indent: 0,
          type: 'paragraph',
          version: 1
        }
      ],
      direction: null,
      format: '',
      indent: 0,
      type: 'root',
      version: 1
    }
  }
);

export function setEditorState(editor: LexicalEditor, editorStateJson: any) {
    const importstate = editor.parseEditorState(editorStateJson);
    editor.setEditorState(importstate)
}

export function clearEditorState(editor: LexicalEditor) {
      const initialState = editor.parseEditorState(editorInitialJSON);
     editor.setEditorState(initialState);
}

export function editorIsEmpty(editor:LexicalEditor): boolean {
  const currentState = editor.getEditorState().toJSON();
  return currentState.root.children.length === 1 && (currentState.root.children[0] as any).children.length === 0;
}


export function clearAndFocusEditor(editor:LexicalEditor){
  editor.update(() => {
    const root = $getRoot();

    $getRoot();
    root.clear();
    const paragraph = $createParagraphNode();
    root.append(paragraph);
    paragraph.select();
  });
}